import React from "react";
import "./Header.scss";
import images from "../../../../utilities/images/images";
import { useHistory } from "react-router-dom";

const Header = ({ paperName }) => {
  const navigate = useHistory();

  const handleBackClick = () => {
    navigate.push("/analytics");
  };

  return (
    <div className="analytics__header">
      <div
        className="analytics__header__left"
        onClick={handleBackClick}
        style={{ cursor: "pointer" }}
      >
        <img src={images.backBtn} alt="backbtn" />
        <div>{paperName}</div>
      </div>

      <div className="analytics__header__right">Analytics</div>
    </div>
  );
};

export default Header;
